import React from 'react';
import {
    Link
  } from "react-router-dom";

import Modal from 'react-bootstrap/Modal';

import thanks from '../../images/thank-you.png';

class _Modal extends React.PureComponent{
    render(){
        var info = "";
        switch(this.props.version){
            case 'feedback':
            info = <p>You made our day</p>;
            break;

            case 'request':
                info = <p>We will notify you as soon as we get a permission from our client.If you don’t receive an email from us within 24 hours please check your Spam Box.</p>;

            break;

            case 'quote':
                info = <p>Thank you for reaching out to us! We will review your request and provide pricing within 24 hours. If you don’t receive an email from us within 24 hours please check your Spam Box.</p>;

            break;

            default:
                info = <p>Something great is headed your way! <br></br><br></br>
                Our sales specialist will get back to you as soon as possible. If you don’t receive an email from us within 24 hours please check your Spam Box.</p>;

                break;
        }
        return(
            <Modal show={this.props.show} onHide={this.props.hide} centered>
                    <span className="hide" onClick={this.props.hide}>X</span>
                    {(this.props.loaded) ?
                    <Modal.Body>
                        
                        <img src={thanks} alt="Thanks"></img>

                        {info}

                        <span className="thanks">THANK YOU</span>

                        <Link className="back-home" to="/">Back Home</Link>
                    </Modal.Body>

                    :
                    <Modal.Body>
                        <div class="spinner-border animate-spin" role="status">
                            <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">

                            </svg>
                            <span class="sr-only">Loading...</span>
                        </div>
                    </Modal.Body>

                    }
            </Modal>
        );
    }
}

export default _Modal;